<template>
	<div class="pagesContent">
				<el-card>
					<el-form inline ref="Search" :model="Search" label-width="100px">
						<el-form-item label="公司编号">
							<el-input v-model="Search.CompanyId" placeholder="请输入公司编号" size="small" @change="searchSubmit"></el-input>
						</el-form-item>
						<el-form-item label="公司名称">
							<el-input v-model="Search.LikeCompanyName" placeholder="请输入公司名称" size="small" @change="searchSubmit">
							</el-input>
						</el-form-item>
						<el-form-item label="系统类型">
							<el-select v-model="Search.SystemTypeId" clearable placeholder="请选择系统类型" @change="searchSubmit" size="small">
								<el-option v-for="item in systemtypeIdOptions" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="维护人">
							<el-select v-model="Search.TBEmployeeJobNumber" clearable placeholder="请选择维护人" @change="searchSubmit" size="small">
								<el-option v-for="item in staffOptions" :key="item.jobId" :label="item.name"
									:value="item.jobId"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="地区">
							<el-cascader size="small" :options="options" v-model="selectedOptions" clearable
								:props="{ checkStrictly: true }" popper-class='aaa' @change="chooseRegion">
							</el-cascader>
						</el-form-item>
					</el-form>
				</el-card>
			<!-- 主体内容 -->
				<el-card style="margin-top: 10px;">
					<!-- 表格  条纹 stripe 边框 border -->
					<el-table size="mini" max-height="500" :data="companyList" highlight-current-row stripe>
						<!-- 展开行 -->
						<el-table-column type="expand" align="center">
							<template slot-scope="props">
								<el-form label-position="left" inline class="demo-table-expand">
									<el-form-item label="负 责 人">
										<span>{{ props.row.PersonIncharge }}</span>
									</el-form-item>
									<el-form-item label="对接负责人">
										<span>{{ props.row.TBPersonIncharge }}</span>
									</el-form-item>
									<el-form-item label="移动电话">
										<span>{{ props.row.MobilePhone }}</span>
									</el-form-item>
									<el-form-item label="对接负责人电话">
										<span>{{ props.row.TBContactinformation }}</span>
									</el-form-item>
									<el-form-item label="固定电话">
										<span>{{ props.row.Contactinformation }}</span>
									</el-form-item>
									<el-form-item label="地  址">
										<span>{{ props.row.Provinces.Name}}-{{ props.row.City.Name}}-{{ props.row.Areas.Name}}</span>
									</el-form-item>
									<el-form-item label="服务器电脑名">
										<span>{{ props.row.ServerHostName }}</span>
									</el-form-item>
									<el-form-item label="详细地址">
										<span>{{ props.row.DetailedAddress }}</span>
									</el-form-item>
								</el-form>
							</template>
						</el-table-column>
						<el-table-column type="index" label="编号" align="center" min-width="50"></el-table-column>
						<el-table-column prop="CompanyId" label="公司编号" align="center" min-width="160">
						</el-table-column>
						<el-table-column prop="CompanyName" label="公司名称" align="center" min-width="200"></el-table-column>
						<el-table-column prop="SystemType.Name" label="系统类型" header-align="center" min-width="80" align="center">
						</el-table-column>
						<el-table-column prop="SystemType.Deadline" label="到期时间" header-align="center" min-width="100" align="center">
							<template slot-scope="scope">
								{{scope.row.Deadline | dateYMDFormat}}
							</template>
						</el-table-column>
						<el-table-column prop="SystemType.Deadline" label="最后更新时间" header-align="center" min-width="100" align="center">
							<template slot-scope="scope">
								{{scope.row.LastUpdateTime | dateYMDFormat}}
							</template>
						</el-table-column>
						<el-table-column prop="TBEmployee.Name" label="维护人" header-align="center" min-width="80" align="center"
							width="120"></el-table-column>
						<el-table-column label="操作" align="center" fixed="right">
							<template slot-scope="scope">
								<el-button size="mini" type="primary"
									@click="handleAuditFactory(scope.$index, scope.row)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination style="padding-top: 10px;" background :current-page.sync="table.pageIndex" :page-size.sync="table.pageSize"
						:page-sizes="[10, 20, 40, 50]" layout="total,sizes, prev, pager, next" :total="table.TotalCount"
						@size-change="handleSizeChange" @current-change="getCompanyAll">
					</el-pagination>
				</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//获取地区
				options: [],
				selectedOptions: [],
				//顶部搜索
				Search: {
					CompanyId: '', //公司编号
					LikeCompanyName: '', // 公司名称
					// Deadline: '',  //软件到期时间
					ProvinceCode: '', //省代码
					CityCode: '', //市代码
					AreaCode: '', //区代码
					SystemTypeId: 0, //系统类型
					TBEmployeeJobNumber: "" //维护人
				},
				table:{
					pageIndex:1,
					pageSize:10,
					TotalCount:null,
				},
				//系统版本类型（单机版、网络版...）
				systemtypeIdOptions: [],
				//维护人 本公司所有员工
				staffOptions: [],
				//公司列表
				companyList: [],
				//备份公司列表
				companyListBackups: []
			}
		},
		mounted() {
			//获取地区
			this.getAddress()
			// console.log(this.options)
			//查询所有系统类型
			this.getSystemtypeAll()
			//查询所有公司列表
			this.getCompanyAll()
			//查询维护人 即员工列表 (在职 )
			this.getStaffList()
		},
		methods: {
			/* 获取地区 */
			getAddress() {
				this.$http.getAllAddress().then(res => {
					if (res.status == 200) {
						this.options = res.data
						// console.log(this.options)
					} else {
						this.$message.error({
							message: '查询地区失败！'
						})
					}
				})
			},
			handleSizeChange(val) {
				this.table.pageIndex = 1
				this.getCompanyAll()
			},
			/* 顶部选择地区 */
			chooseRegion(value) {
				// console.log(value)
				var regionList = value
				if (value.length == 3) {
					this.Search.ProvinceCode = regionList[0]
					this.Search.CityCode = regionList[1]
					this.Search.AreaCode = regionList[2]
				} else if (value.length == 2) {
					this.Search.ProvinceCode = regionList[0]
					this.Search.CityCode = regionList[1]
					this.Search.AreaCode = ""
				} else if (value.length == 1) {
					this.Search.ProvinceCode = regionList[0]
					this.Search.CityCode = ""
					this.Search.AreaCode = ""
				} else {
					this.Search.ProvinceCode = ""
					this.Search.CityCode = ""
					this.Search.AreaCode = ""
				}
				this.searchSubmit()
			},
			/* 查询维护人 即员工列表 (在职 ) */
			getStaffList(SearchFlag) {
				let status = '?flag=1'
				this.$http.getStaffList(status).then(res => {
					if (res.status == 200) {
						var staffList = res.data
						for (var i = 0; i < staffList.length; i++) {
							var staff = {
								jobId: staffList[i].JobNumber,
								name: staffList[i].Name
							}
							this.staffOptions.push(staff)
						}
					} else {
						this.$message.error({
							message: '查询所有在职员工失败！'
						})
					}
				})
			},
			/* 查询所有公司列表 */
			getCompanyAll() {
				this.$http.getAllPlantMsgPag(this.table.pageIndex,this.table.pageSize,this.Search).then(res => {
					console.log(res)
					if (res.status == 200) {
						// console.log(res.data)
						this.companyList = res.data.Items
						this.table.TotalCount = res.data.TotalCount
						this.companyListBackups = res.data.Items //备份公司列表
					}
				})
			},
			/* 查询所有系统类型 */
			getSystemtypeAll() {
				this.$http.getSystemAll().then(res => {
					if (res.status == 200) {
						var SystemtypeData = res.data
						//遍历数据 构造版本类型新数组
						var system = {
							id: 0,
							name: '全部'
						}
						this.systemtypeIdOptions.push(system)
						for (var i = 0; i < SystemtypeData.length; i++) {
							// console.log(i)
							var system = {
								id: SystemtypeData[i].Id,
								name: SystemtypeData[i].Name
							}
							this.systemtypeIdOptions.push(system)
						}
					} else {
						this.$message.error({
							message: '查询版本类型信息失败！'
						})
					}
				})
			},
			/* 点击查看单个公司信息 */
			handleAuditFactory(index, row) {
				//携带 本行公司id 查看公司信息
				this.$router.push({
					path: '/factoryManage/factoryInfo',
					query: {
						CompanyId: row.CompanyId
					}
				})
			},
			/* 搜索 提交搜索 */
			searchSubmit() {
				this.table.pageIndex = 1
				this.getCompanyAll()
			}
		}
	}
</script>

<style>
	.pagesContent {
		width: 100%;
		height: 100%;
	}

	.main-box {
		width: 100%;
		background-color: #FFFFFF;
	}

	/* 列表展开样式 */
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 110px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 49%;
	}

	/* 顶部地址 */
	.el-cascader-menu__wrap {
		height: 260px;
	}

	.el-cascader-menu {
		min-width: 260px;
	}

	.el-cascader-panel {
		font-size: 16px;
	}

	.aaa .el-radio__inner {
		top: -18px;
		left: -19px;
		border-radius: 0;
		border: 0;
		width: 170px;
		height: 34px;
		background-color: transparent;
		cursor: pointer;
		box-sizing: border-box;
		position: absolute;
	}

	.aaa .el-radio__input.is-checked .el-radio__inner {
		background: transparent;
	}
	.el-card__body{
		padding: 10px;
	}
</style>
